// icons
import { Icon } from "@iconify/react";
// @mui
import Box from "@mui/material/Box";
//

const Iconify = ({ icon, sx, ref, ...other }) => (
  <Box
    ref={ref}
    component={Icon}
    className="component-iconify"
    icon={icon}
    sx={{
      width: 20,
      height: 20,
      flexShrink: 0, 
      ...sx,
    }}
    {...other}
  />
);

export default Iconify;
